// ─── DevOps · Valoraciones, un cliente ───
//
// `/app/devops/{slug}-{short}` (ADR 0012). El `short` son los seis últimos hex del id de PLANI,
// y es lo único que resuelve: el slug es cosmético y un renombrado no rompe el enlace.

import { createFileRoute } from '@tanstack/react-router';
import { DevOpsClienteRoute } from '../../features/devops/DevOpsClienteRoute';

export const Route = createFileRoute('/app/devops/$clienteRef')({
  component: DevOpsClienteRoute,
});
